//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fuse from 'fuse.js'

export default {
  props: {
    articles: { type: Array, required: true }
  },
  data () {
    return {
      query: null
    }
  },
  computed: {
    searchResults () {
      if (this.query) {
        const results = []
        this.fuse.search(this.query.substring(0, 32)).forEach((result) => {
          if (results.find(r2 => r2.item.id === result.item.id)) return
          results.push(result)
        })
        return results
      }
      return []
    }
  },
  watch: {
    query () {
      this.trackSearch()
    }
  },
  mounted () {
    // Create Fuse.js instance
    this.fuse = new Fuse(this.articles, {
      includeScore: true,
      includeMatches: true,
      threshold: 0.4,
      maxPatternLength: 64,
      keys: ['title', 'body', 'keywords']
    })

    // Debounce search tracker
    this.trackSearch = this.debounce(this.trackSearch, 1000)
  },
  methods: {
    trackSearch () {
      if (!this.query) return
      this.$store.dispatch('support/TRACK_SEARCH', { query: this.query, results: this.searchResults.length })
    }
  }
}
